export default __webpack_public_path__ + "static/understand-data-ae431fcd6c0187caedee3ebe3e7340ce.png";